export default __webpack_public_path__ + "static/media/bulmaback.99a85ce0.svg";